<div class="d-flex align-items-center justify-content-center" style="height: 100vh; width: 100vw">
  <div class="login-form-bg pb-5">
    <div class="d-flex justify-content-center form-title py-3" style="width: 100%">
      <p class="fs-4 mb-0 text-black">Sign Up</p>
    </div>
    <form nz-form class="login-form" (ngSubmit)="submitForm()">
      <nz-form-item>
        <nz-form-control nzErrorTip="Please input your username!">
          <nz-input-group nzPrefixIcon="phone">
            <input type="text" nz-input [formControl]="mobileNumber" placeholder="Mobile Number" />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      <button nz-button class="login-form-button mt-2 w-100" [nzType]="'primary'">
        Get Code
      </button>
      <div class="row text-center mt-3">
        <div>
          Do have an account? <a class="login-form-forgot" (click)="onSignIn()">Sign In</a>
        </div>
      </div>
    </form>
  </div>
</div>
